import { IconButton, IconButtonProps } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

const SquareIconButton: React.FC<IconButtonProps> = ({
  children,
  className,
  ...props
}) => (
  <IconButton
    className={cn(
      'bg-brand-navy! text-secondary-contrast! rounded! p-2!',
      className,
    )}
    {...props}
  >
    {children}
  </IconButton>
);

export default SquareIconButton;
